// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/KaTeX_AMS-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/KaTeX_AMS-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/KaTeX_AMS-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fonts/KaTeX_Caligraphic-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("fonts/KaTeX_Caligraphic-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("fonts/KaTeX_Caligraphic-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("fonts/KaTeX_Caligraphic-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("fonts/KaTeX_Caligraphic-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("fonts/KaTeX_Caligraphic-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("fonts/KaTeX_Fraktur-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("fonts/KaTeX_Fraktur-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("fonts/KaTeX_Fraktur-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("fonts/KaTeX_Fraktur-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("fonts/KaTeX_Fraktur-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("fonts/KaTeX_Fraktur-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("fonts/KaTeX_Main-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("fonts/KaTeX_Main-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("fonts/KaTeX_Main-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("fonts/KaTeX_Main-BoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("fonts/KaTeX_Main-BoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("fonts/KaTeX_Main-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("fonts/KaTeX_Main-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("fonts/KaTeX_Main-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("fonts/KaTeX_Main-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("fonts/KaTeX_Main-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("fonts/KaTeX_Main-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("fonts/KaTeX_Main-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("fonts/KaTeX_Math-BoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("fonts/KaTeX_Math-BoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("fonts/KaTeX_Math-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("fonts/KaTeX_Math-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("fonts/KaTeX_Math-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("fonts/KaTeX_Math-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("fonts/KaTeX_SansSerif-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("fonts/KaTeX_SansSerif-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("fonts/KaTeX_SansSerif-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("fonts/KaTeX_SansSerif-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("fonts/KaTeX_SansSerif-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("fonts/KaTeX_SansSerif-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("fonts/KaTeX_SansSerif-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("fonts/KaTeX_SansSerif-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("fonts/KaTeX_SansSerif-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("fonts/KaTeX_Script-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("fonts/KaTeX_Script-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("fonts/KaTeX_Script-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("fonts/KaTeX_Size1-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("fonts/KaTeX_Size1-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("fonts/KaTeX_Size1-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("fonts/KaTeX_Size2-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("fonts/KaTeX_Size2-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("fonts/KaTeX_Size2-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("fonts/KaTeX_Size3-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("fonts/KaTeX_Size3-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("fonts/KaTeX_Size3-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("fonts/KaTeX_Size4-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("fonts/KaTeX_Size4-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("fonts/KaTeX_Size4-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("fonts/KaTeX_Typewriter-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("fonts/KaTeX_Typewriter-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_59___ = new URL("fonts/KaTeX_Typewriter-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_59___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable font-family-no-missing-generic-family-keyword */
@font-face {
    font-family: "KaTeX_AMS";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: "KaTeX_Caligraphic";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
    font-weight: bold;
    font-style: normal;
  }
  @font-face {
    font-family: "KaTeX_Caligraphic";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: "KaTeX_Fraktur";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("truetype");
    font-weight: bold;
    font-style: normal;
  }
  @font-face {
    font-family: "KaTeX_Fraktur";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype");
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: "KaTeX_Main";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("truetype");
    font-weight: bold;
    font-style: normal;
  }
  @font-face {
    font-family: "KaTeX_Main";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("truetype");
    font-weight: bold;
    font-style: italic;
  }
  @font-face {
    font-family: "KaTeX_Main";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("truetype");
    font-weight: normal;
    font-style: italic;
  }
  @font-face {
    font-family: "KaTeX_Main";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("truetype");
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: "KaTeX_Math";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("truetype");
    font-weight: bold;
    font-style: italic;
  }
  @font-face {
    font-family: "KaTeX_Math";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("truetype");
    font-weight: normal;
    font-style: italic;
  }
  @font-face {
    font-family: "KaTeX_SansSerif";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_35___}) format("truetype");
    font-weight: bold;
    font-style: normal;
  }
  @font-face {
    font-family: "KaTeX_SansSerif";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_36___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_37___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_38___}) format("truetype");
    font-weight: normal;
    font-style: italic;
  }
  @font-face {
    font-family: "KaTeX_SansSerif";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_39___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_40___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_41___}) format("truetype");
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: "KaTeX_Script";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_42___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_43___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_44___}) format("truetype");
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: "KaTeX_Size1";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_45___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_46___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_47___}) format("truetype");
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: "KaTeX_Size2";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_48___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_49___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_50___}) format("truetype");
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: "KaTeX_Size3";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_51___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_52___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_53___}) format("truetype");
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: "KaTeX_Size4";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_54___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_55___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_56___}) format("truetype");
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: "KaTeX_Typewriter";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_57___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_58___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_59___}) format("truetype");
    font-weight: normal;
    font-style: normal;
  }
  .katex {
    font: normal 1.21em KaTeX_Main, Times New Roman, serif;
    line-height: 1.2;
    text-indent: 0;
    text-rendering: auto;
  }
  .katex * {
    -ms-high-contrast-adjust: none !important;
  }
  .katex * {
    border-color: currentColor;
  }
  .katex .katex-version::after {
    content: "0.16.11";
  }

  .katex .katex-html > .newline {
    display: block;
  }
  .katex .base {
    position: relative;
    display: inline-block;
    white-space: nowrap;
    width: -webkit-min-content;
    width: -moz-min-content;
    width: min-content;
  }
  .katex .strut {
    display: inline-block;
  }
  .katex .textbf {
    font-weight: bold;
  }
  .katex .textit {
    font-style: italic;
  }
  .katex .textrm {
    font-family: KaTeX_Main;
  }
  .katex .textsf {
    font-family: KaTeX_SansSerif;
  }
  .katex .texttt {
    font-family: KaTeX_Typewriter;
  }
  .katex .mathnormal {
    font-family: KaTeX_Math;
    font-style: italic;
  }
  .katex .mathit {
    font-family: KaTeX_Main;
    font-style: italic;
  }
  .katex .mathrm {
    font-style: normal;
  }
  .katex .mathbf {
    font-family: KaTeX_Main;
    font-weight: bold;
  }
  .katex .boldsymbol {
    font-family: KaTeX_Math;
    font-weight: bold;
    font-style: italic;
  }
  .katex .amsrm {
    font-family: KaTeX_AMS;
  }
  .katex .mathbb,
  .katex .textbb {
    font-family: KaTeX_AMS;
  }
  .katex .mathcal {
    font-family: KaTeX_Caligraphic;
  }
  .katex .mathfrak,
  .katex .textfrak {
    font-family: KaTeX_Fraktur;
  }
  .katex .mathboldfrak,
  .katex .textboldfrak {
    font-family: KaTeX_Fraktur;
    font-weight: bold;
  }
  .katex .mathtt {
    font-family: KaTeX_Typewriter;
  }
  .katex .mathscr,
  .katex .textscr {
    font-family: KaTeX_Script;
  }
  .katex .mathsf,
  .katex .textsf {
    font-family: KaTeX_SansSerif;
  }
  .katex .mathboldsf,
  .katex .textboldsf {
    font-family: KaTeX_SansSerif;
    font-weight: bold;
  }
  .katex .mathitsf,
  .katex .textitsf {
    font-family: KaTeX_SansSerif;
    font-style: italic;
  }
  .katex .mainrm {
    font-family: KaTeX_Main;
    font-style: normal;
  }
  .katex .vlist-t {
    display: inline-table;
    table-layout: fixed;
    border-collapse: collapse;
  }
  .katex .vlist-r {
    display: table-row;
  }
  .katex .vlist {
    display: table-cell;
    vertical-align: bottom;
    position: relative;
  }
  .katex .vlist > span {
    display: block;
    height: 0;
    position: relative;
  }
  .katex .vlist > span > span {
    display: inline-block;
  }
  .katex .vlist > span > .pstrut {
    overflow: hidden;
    width: 0;
  }
  .katex .vlist-t2 {
    margin-right: -2px;
  }
  .katex .vlist-s {
    display: table-cell;
    vertical-align: bottom;
    font-size: 1px;
    width: 2px;
    min-width: 2px;
  }
  .katex .vbox {
    display: inline-flex;
    flex-direction: column;
    align-items: baseline;
  }
  .katex .hbox {
    display: inline-flex;
    flex-direction: row;
    width: 100%;
  }
  .katex .thinbox {
    display: inline-flex;
    flex-direction: row;
    width: 0;
    max-width: 0;
  }
  .katex .msupsub {
    text-align: left;
  }
  .katex .mfrac > span > span {
    text-align: center;
  }
  .katex .mfrac .frac-line {
    display: inline-block;
    width: 100%;
    border-bottom-style: solid;
  }
  .katex .mfrac .frac-line,
  .katex .overline .overline-line,
  .katex .underline .underline-line,
  .katex .hline,
  .katex .hdashline,
  .katex .rule {
    min-height: 1px;
  }
  .katex .mspace {
    display: inline-block;
  }
  .katex .llap,
  .katex .rlap,
  .katex .clap {
    width: 0;
    position: relative;
  }
  .katex .llap > .inner,
  .katex .rlap > .inner,
  .katex .clap > .inner {
    position: absolute;
  }
  .katex .llap > .fix,
  .katex .rlap > .fix,
  .katex .clap > .fix {
    display: inline-block;
  }
  .katex .llap > .inner {
    right: 0;
  }
  .katex .rlap > .inner,
  .katex .clap > .inner {
    left: 0;
  }
  .katex .clap > .inner > span {
    margin-left: -50%;
    margin-right: 50%;
  }
  .katex .rule {
    display: inline-block;
    border: solid 0;
    position: relative;
  }
  .katex .overline .overline-line,
  .katex .underline .underline-line,
  .katex .hline {
    display: inline-block;
    width: 100%;
    border-bottom-style: solid;
  }
  .katex .hdashline {
    display: inline-block;
    width: 100%;
    border-bottom-style: dashed;
  }
  .katex .sqrt > .root {
    /* These values are taken from the definition of \`\\r@@t\`,
     \`\\mkern 5mu\` and \`\\mkern -10mu\`. */
    margin-left: 0.2777777778em;
    margin-right: -0.5555555556em;
  }
  .katex .sizing.reset-size1.size1,
  .katex .fontsize-ensurer.reset-size1.size1 {
    /* stylelint-disable-next-line */
    font-size: 1em;
  }
  .katex .sizing.reset-size1.size2,
  .katex .fontsize-ensurer.reset-size1.size2 {
    /* stylelint-disable-next-line */
    font-size: 1.2em;
  }
  .katex .sizing.reset-size1.size3,
  .katex .fontsize-ensurer.reset-size1.size3 {
    /* stylelint-disable-next-line */
    font-size: 1.4em;
  }
  .katex .sizing.reset-size1.size4,
  .katex .fontsize-ensurer.reset-size1.size4 {
    /* stylelint-disable-next-line */
    font-size: 1.6em;
  }
  .katex .sizing.reset-size1.size5,
  .katex .fontsize-ensurer.reset-size1.size5 {
    /* stylelint-disable-next-line */
    font-size: 1.8em;
  }
  .katex .sizing.reset-size1.size6,
  .katex .fontsize-ensurer.reset-size1.size6 {
    /* stylelint-disable-next-line */
    font-size: 2em;
  }
  .katex .sizing.reset-size1.size7,
  .katex .fontsize-ensurer.reset-size1.size7 {
    /* stylelint-disable-next-line */
    font-size: 2.4em;
  }
  .katex .sizing.reset-size1.size8,
  .katex .fontsize-ensurer.reset-size1.size8 {
    /* stylelint-disable-next-line */
    font-size: 2.88em;
  }
  .katex .sizing.reset-size1.size9,
  .katex .fontsize-ensurer.reset-size1.size9 {
    /* stylelint-disable-next-line */
    font-size: 3.456em;
  }
  .katex .sizing.reset-size1.size10,
  .katex .fontsize-ensurer.reset-size1.size10 {
    /* stylelint-disable-next-line */
    font-size: 4.148em;
  }
  .katex .sizing.reset-size1.size11,
  .katex .fontsize-ensurer.reset-size1.size11 {
    /* stylelint-disable-next-line */
    font-size: 4.976em;
  }
  .katex .sizing.reset-size2.size1,
  .katex .fontsize-ensurer.reset-size2.size1 {
    /* stylelint-disable-next-line */
    font-size: 0.8333333333em;
  }
  .katex .sizing.reset-size2.size2,
  .katex .fontsize-ensurer.reset-size2.size2 {
    /* stylelint-disable-next-line */
    font-size: 1em;
  }
  .katex .sizing.reset-size2.size3,
  .katex .fontsize-ensurer.reset-size2.size3 {
    /* stylelint-disable-next-line */
    font-size: 1.1666666667em;
  }
  .katex .sizing.reset-size2.size4,
  .katex .fontsize-ensurer.reset-size2.size4 {
    /* stylelint-disable-next-line */
    font-size: 1.3333333333em;
  }
  .katex .sizing.reset-size2.size5,
  .katex .fontsize-ensurer.reset-size2.size5 {
    /* stylelint-disable-next-line */
    font-size: 1.5em;
  }
  .katex .sizing.reset-size2.size6,
  .katex .fontsize-ensurer.reset-size2.size6 {
    /* stylelint-disable-next-line */
    font-size: 1.6666666667em;
  }
  .katex .sizing.reset-size2.size7,
  .katex .fontsize-ensurer.reset-size2.size7 {
    /* stylelint-disable-next-line */
    font-size: 2em;
  }
  .katex .sizing.reset-size2.size8,
  .katex .fontsize-ensurer.reset-size2.size8 {
    /* stylelint-disable-next-line */
    font-size: 2.4em;
  }
  .katex .sizing.reset-size2.size9,
  .katex .fontsize-ensurer.reset-size2.size9 {
    /* stylelint-disable-next-line */
    font-size: 2.88em;
  }
  .katex .sizing.reset-size2.size10,
  .katex .fontsize-ensurer.reset-size2.size10 {
    /* stylelint-disable-next-line */
    font-size: 3.4566666667em;
  }
  .katex .sizing.reset-size2.size11,
  .katex .fontsize-ensurer.reset-size2.size11 {
    /* stylelint-disable-next-line */
    font-size: 4.1466666667em;
  }
  .katex .sizing.reset-size3.size1,
  .katex .fontsize-ensurer.reset-size3.size1 {
    /* stylelint-disable-next-line */
    font-size: 0.7142857143em;
  }
  .katex .sizing.reset-size3.size2,
  .katex .fontsize-ensurer.reset-size3.size2 {
    /* stylelint-disable-next-line */
    font-size: 0.8571428571em;
  }
  .katex .sizing.reset-size3.size3,
  .katex .fontsize-ensurer.reset-size3.size3 {
    /* stylelint-disable-next-line */
    font-size: 1em;
  }
  .katex .sizing.reset-size3.size4,
  .katex .fontsize-ensurer.reset-size3.size4 {
    /* stylelint-disable-next-line */
    font-size: 1.1428571429em;
  }
  .katex .sizing.reset-size3.size5,
  .katex .fontsize-ensurer.reset-size3.size5 {
    /* stylelint-disable-next-line */
    font-size: 1.2857142857em;
  }
  .katex .sizing.reset-size3.size6,
  .katex .fontsize-ensurer.reset-size3.size6 {
    /* stylelint-disable-next-line */
    font-size: 1.4285714286em;
  }
  .katex .sizing.reset-size3.size7,
  .katex .fontsize-ensurer.reset-size3.size7 {
    /* stylelint-disable-next-line */
    font-size: 1.7142857143em;
  }
  .katex .sizing.reset-size3.size8,
  .katex .fontsize-ensurer.reset-size3.size8 {
    /* stylelint-disable-next-line */
    font-size: 2.0571428571em;
  }
  .katex .sizing.reset-size3.size9,
  .katex .fontsize-ensurer.reset-size3.size9 {
    /* stylelint-disable-next-line */
    font-size: 2.4685714286em;
  }
  .katex .sizing.reset-size3.size10,
  .katex .fontsize-ensurer.reset-size3.size10 {
    /* stylelint-disable-next-line */
    font-size: 2.9628571429em;
  }
  .katex .sizing.reset-size3.size11,
  .katex .fontsize-ensurer.reset-size3.size11 {
    /* stylelint-disable-next-line */
    font-size: 3.5542857143em;
  }
  .katex .sizing.reset-size4.size1,
  .katex .fontsize-ensurer.reset-size4.size1 {
    /* stylelint-disable-next-line */
    font-size: 0.625em;
  }
  .katex .sizing.reset-size4.size2,
  .katex .fontsize-ensurer.reset-size4.size2 {
    /* stylelint-disable-next-line */
    font-size: 0.75em;
  }
  .katex .sizing.reset-size4.size3,
  .katex .fontsize-ensurer.reset-size4.size3 {
    /* stylelint-disable-next-line */
    font-size: 0.875em;
  }
  .katex .sizing.reset-size4.size4,
  .katex .fontsize-ensurer.reset-size4.size4 {
    /* stylelint-disable-next-line */
    font-size: 1em;
  }
  .katex .sizing.reset-size4.size5,
  .katex .fontsize-ensurer.reset-size4.size5 {
    /* stylelint-disable-next-line */
    font-size: 1.125em;
  }
  .katex .sizing.reset-size4.size6,
  .katex .fontsize-ensurer.reset-size4.size6 {
    /* stylelint-disable-next-line */
    font-size: 1.25em;
  }
  .katex .sizing.reset-size4.size7,
  .katex .fontsize-ensurer.reset-size4.size7 {
    /* stylelint-disable-next-line */
    font-size: 1.5em;
  }
  .katex .sizing.reset-size4.size8,
  .katex .fontsize-ensurer.reset-size4.size8 {
    /* stylelint-disable-next-line */
    font-size: 1.8em;
  }
  .katex .sizing.reset-size4.size9,
  .katex .fontsize-ensurer.reset-size4.size9 {
    /* stylelint-disable-next-line */
    font-size: 2.16em;
  }
  .katex .sizing.reset-size4.size10,
  .katex .fontsize-ensurer.reset-size4.size10 {
    /* stylelint-disable-next-line */
    font-size: 2.5925em;
  }
  .katex .sizing.reset-size4.size11,
  .katex .fontsize-ensurer.reset-size4.size11 {
    /* stylelint-disable-next-line */
    font-size: 3.11em;
  }
  .katex .sizing.reset-size5.size1,
  .katex .fontsize-ensurer.reset-size5.size1 {
    /* stylelint-disable-next-line */
    font-size: 0.5555555556em;
  }
  .katex .sizing.reset-size5.size2,
  .katex .fontsize-ensurer.reset-size5.size2 {
    /* stylelint-disable-next-line */
    font-size: 0.6666666667em;
  }
  .katex .sizing.reset-size5.size3,
  .katex .fontsize-ensurer.reset-size5.size3 {
    /* stylelint-disable-next-line */
    font-size: 0.7777777778em;
  }
  .katex .sizing.reset-size5.size4,
  .katex .fontsize-ensurer.reset-size5.size4 {
    /* stylelint-disable-next-line */
    font-size: 0.8888888889em;
  }
  .katex .sizing.reset-size5.size5,
  .katex .fontsize-ensurer.reset-size5.size5 {
    /* stylelint-disable-next-line */
    font-size: 1em;
  }
  .katex .sizing.reset-size5.size6,
  .katex .fontsize-ensurer.reset-size5.size6 {
    /* stylelint-disable-next-line */
    font-size: 1.1111111111em;
  }
  .katex .sizing.reset-size5.size7,
  .katex .fontsize-ensurer.reset-size5.size7 {
    /* stylelint-disable-next-line */
    font-size: 1.3333333333em;
  }
  .katex .sizing.reset-size5.size8,
  .katex .fontsize-ensurer.reset-size5.size8 {
    /* stylelint-disable-next-line */
    font-size: 1.6em;
  }
  .katex .sizing.reset-size5.size9,
  .katex .fontsize-ensurer.reset-size5.size9 {
    /* stylelint-disable-next-line */
    font-size: 1.92em;
  }
  .katex .sizing.reset-size5.size10,
  .katex .fontsize-ensurer.reset-size5.size10 {
    /* stylelint-disable-next-line */
    font-size: 2.3044444444em;
  }
  .katex .sizing.reset-size5.size11,
  .katex .fontsize-ensurer.reset-size5.size11 {
    /* stylelint-disable-next-line */
    font-size: 2.7644444444em;
  }
  .katex .sizing.reset-size6.size1,
  .katex .fontsize-ensurer.reset-size6.size1 {
    /* stylelint-disable-next-line */
    font-size: 0.5em;
  }
  .katex .sizing.reset-size6.size2,
  .katex .fontsize-ensurer.reset-size6.size2 {
    /* stylelint-disable-next-line */
    font-size: 0.6em;
  }
  .katex .sizing.reset-size6.size3,
  .katex .fontsize-ensurer.reset-size6.size3 {
    /* stylelint-disable-next-line */
    font-size: 0.7em;
  }
  .katex .sizing.reset-size6.size4,
  .katex .fontsize-ensurer.reset-size6.size4 {
    /* stylelint-disable-next-line */
    font-size: 0.8em;
  }
  .katex .sizing.reset-size6.size5,
  .katex .fontsize-ensurer.reset-size6.size5 {
    /* stylelint-disable-next-line */
    font-size: 0.9em;
  }
  .katex .sizing.reset-size6.size6,
  .katex .fontsize-ensurer.reset-size6.size6 {
    /* stylelint-disable-next-line */
    font-size: 1em;
  }
  .katex .sizing.reset-size6.size7,
  .katex .fontsize-ensurer.reset-size6.size7 {
    /* stylelint-disable-next-line */
    font-size: 1.2em;
  }
  .katex .sizing.reset-size6.size8,
  .katex .fontsize-ensurer.reset-size6.size8 {
    /* stylelint-disable-next-line */
    font-size: 1.44em;
  }
  .katex .sizing.reset-size6.size9,
  .katex .fontsize-ensurer.reset-size6.size9 {
    /* stylelint-disable-next-line */
    font-size: 1.728em;
  }
  .katex .sizing.reset-size6.size10,
  .katex .fontsize-ensurer.reset-size6.size10 {
    /* stylelint-disable-next-line */
    font-size: 2.074em;
  }
  .katex .sizing.reset-size6.size11,
  .katex .fontsize-ensurer.reset-size6.size11 {
    /* stylelint-disable-next-line */
    font-size: 2.488em;
  }
  .katex .sizing.reset-size7.size1,
  .katex .fontsize-ensurer.reset-size7.size1 {
    /* stylelint-disable-next-line */
    font-size: 0.4166666667em;
  }
  .katex .sizing.reset-size7.size2,
  .katex .fontsize-ensurer.reset-size7.size2 {
    /* stylelint-disable-next-line */
    font-size: 0.5em;
  }
  .katex .sizing.reset-size7.size3,
  .katex .fontsize-ensurer.reset-size7.size3 {
    /* stylelint-disable-next-line */
    font-size: 0.5833333333em;
  }
  .katex .sizing.reset-size7.size4,
  .katex .fontsize-ensurer.reset-size7.size4 {
    /* stylelint-disable-next-line */
    font-size: 0.6666666667em;
  }
  .katex .sizing.reset-size7.size5,
  .katex .fontsize-ensurer.reset-size7.size5 {
    /* stylelint-disable-next-line */
    font-size: 0.75em;
  }
  .katex .sizing.reset-size7.size6,
  .katex .fontsize-ensurer.reset-size7.size6 {
    /* stylelint-disable-next-line */
    font-size: 0.8333333333em;
  }
  .katex .sizing.reset-size7.size7,
  .katex .fontsize-ensurer.reset-size7.size7 {
    /* stylelint-disable-next-line */
    font-size: 1em;
  }
  .katex .sizing.reset-size7.size8,
  .katex .fontsize-ensurer.reset-size7.size8 {
    /* stylelint-disable-next-line */
    font-size: 1.2em;
  }
  .katex .sizing.reset-size7.size9,
  .katex .fontsize-ensurer.reset-size7.size9 {
    /* stylelint-disable-next-line */
    font-size: 1.44em;
  }
  .katex .sizing.reset-size7.size10,
  .katex .fontsize-ensurer.reset-size7.size10 {
    /* stylelint-disable-next-line */
    font-size: 1.7283333333em;
  }
  .katex .sizing.reset-size7.size11,
  .katex .fontsize-ensurer.reset-size7.size11 {
    /* stylelint-disable-next-line */
    font-size: 2.0733333333em;
  }
  .katex .sizing.reset-size8.size1,
  .katex .fontsize-ensurer.reset-size8.size1 {
    /* stylelint-disable-next-line */
    font-size: 0.3472222222em;
  }
  .katex .sizing.reset-size8.size2,
  .katex .fontsize-ensurer.reset-size8.size2 {
    /* stylelint-disable-next-line */
    font-size: 0.4166666667em;
  }
  .katex .sizing.reset-size8.size3,
  .katex .fontsize-ensurer.reset-size8.size3 {
    /* stylelint-disable-next-line */
    font-size: 0.4861111111em;
  }
  .katex .sizing.reset-size8.size4,
  .katex .fontsize-ensurer.reset-size8.size4 {
    /* stylelint-disable-next-line */
    font-size: 0.5555555556em;
  }
  .katex .sizing.reset-size8.size5,
  .katex .fontsize-ensurer.reset-size8.size5 {
    /* stylelint-disable-next-line */
    font-size: 0.625em;
  }
  .katex .sizing.reset-size8.size6,
  .katex .fontsize-ensurer.reset-size8.size6 {
    /* stylelint-disable-next-line */
    font-size: 0.6944444444em;
  }
  .katex .sizing.reset-size8.size7,
  .katex .fontsize-ensurer.reset-size8.size7 {
    /* stylelint-disable-next-line */
    font-size: 0.8333333333em;
  }
  .katex .sizing.reset-size8.size8,
  .katex .fontsize-ensurer.reset-size8.size8 {
    /* stylelint-disable-next-line */
    font-size: 1em;
  }
  .katex .sizing.reset-size8.size9,
  .katex .fontsize-ensurer.reset-size8.size9 {
    /* stylelint-disable-next-line */
    font-size: 1.2em;
  }
  .katex .sizing.reset-size8.size10,
  .katex .fontsize-ensurer.reset-size8.size10 {
    /* stylelint-disable-next-line */
    font-size: 1.4402777778em;
  }
  .katex .sizing.reset-size8.size11,
  .katex .fontsize-ensurer.reset-size8.size11 {
    /* stylelint-disable-next-line */
    font-size: 1.7277777778em;
  }
  .katex .sizing.reset-size9.size1,
  .katex .fontsize-ensurer.reset-size9.size1 {
    /* stylelint-disable-next-line */
    font-size: 0.2893518519em;
  }
  .katex .sizing.reset-size9.size2,
  .katex .fontsize-ensurer.reset-size9.size2 {
    /* stylelint-disable-next-line */
    font-size: 0.3472222222em;
  }
  .katex .sizing.reset-size9.size3,
  .katex .fontsize-ensurer.reset-size9.size3 {
    /* stylelint-disable-next-line */
    font-size: 0.4050925926em;
  }
  .katex .sizing.reset-size9.size4,
  .katex .fontsize-ensurer.reset-size9.size4 {
    /* stylelint-disable-next-line */
    font-size: 0.462962963em;
  }
  .katex .sizing.reset-size9.size5,
  .katex .fontsize-ensurer.reset-size9.size5 {
    /* stylelint-disable-next-line */
    font-size: 0.5208333333em;
  }
  .katex .sizing.reset-size9.size6,
  .katex .fontsize-ensurer.reset-size9.size6 {
    /* stylelint-disable-next-line */
    font-size: 0.5787037037em;
  }
  .katex .sizing.reset-size9.size7,
  .katex .fontsize-ensurer.reset-size9.size7 {
    /* stylelint-disable-next-line */
    font-size: 0.6944444444em;
  }
  .katex .sizing.reset-size9.size8,
  .katex .fontsize-ensurer.reset-size9.size8 {
    /* stylelint-disable-next-line */
    font-size: 0.8333333333em;
  }
  .katex .sizing.reset-size9.size9,
  .katex .fontsize-ensurer.reset-size9.size9 {
    /* stylelint-disable-next-line */
    font-size: 1em;
  }
  .katex .sizing.reset-size9.size10,
  .katex .fontsize-ensurer.reset-size9.size10 {
    /* stylelint-disable-next-line */
    font-size: 1.2002314815em;
  }
  .katex .sizing.reset-size9.size11,
  .katex .fontsize-ensurer.reset-size9.size11 {
    /* stylelint-disable-next-line */
    font-size: 1.4398148148em;
  }
  .katex .sizing.reset-size10.size1,
  .katex .fontsize-ensurer.reset-size10.size1 {
    /* stylelint-disable-next-line */
    font-size: 0.2410800386em;
  }
  .katex .sizing.reset-size10.size2,
  .katex .fontsize-ensurer.reset-size10.size2 {
    /* stylelint-disable-next-line */
    font-size: 0.2892960463em;
  }
  .katex .sizing.reset-size10.size3,
  .katex .fontsize-ensurer.reset-size10.size3 {
    /* stylelint-disable-next-line */
    font-size: 0.337512054em;
  }
  .katex .sizing.reset-size10.size4,
  .katex .fontsize-ensurer.reset-size10.size4 {
    /* stylelint-disable-next-line */
    font-size: 0.3857280617em;
  }
  .katex .sizing.reset-size10.size5,
  .katex .fontsize-ensurer.reset-size10.size5 {
    /* stylelint-disable-next-line */
    font-size: 0.4339440694em;
  }
  .katex .sizing.reset-size10.size6,
  .katex .fontsize-ensurer.reset-size10.size6 {
    /* stylelint-disable-next-line */
    font-size: 0.4821600771em;
  }
  .katex .sizing.reset-size10.size7,
  .katex .fontsize-ensurer.reset-size10.size7 {
    /* stylelint-disable-next-line */
    font-size: 0.5785920926em;
  }
  .katex .sizing.reset-size10.size8,
  .katex .fontsize-ensurer.reset-size10.size8 {
    /* stylelint-disable-next-line */
    font-size: 0.6943105111em;
  }
  .katex .sizing.reset-size10.size9,
  .katex .fontsize-ensurer.reset-size10.size9 {
    /* stylelint-disable-next-line */
    font-size: 0.8331726133em;
  }
  .katex .sizing.reset-size10.size10,
  .katex .fontsize-ensurer.reset-size10.size10 {
    /* stylelint-disable-next-line */
    font-size: 1em;
  }
  .katex .sizing.reset-size10.size11,
  .katex .fontsize-ensurer.reset-size10.size11 {
    /* stylelint-disable-next-line */
    font-size: 1.1996142719em;
  }
  .katex .sizing.reset-size11.size1,
  .katex .fontsize-ensurer.reset-size11.size1 {
    /* stylelint-disable-next-line */
    font-size: 0.2009646302em;
  }
  .katex .sizing.reset-size11.size2,
  .katex .fontsize-ensurer.reset-size11.size2 {
    /* stylelint-disable-next-line */
    font-size: 0.2411575563em;
  }
  .katex .sizing.reset-size11.size3,
  .katex .fontsize-ensurer.reset-size11.size3 {
    /* stylelint-disable-next-line */
    font-size: 0.2813504823em;
  }
  .katex .sizing.reset-size11.size4,
  .katex .fontsize-ensurer.reset-size11.size4 {
    /* stylelint-disable-next-line */
    font-size: 0.3215434084em;
  }
  .katex .sizing.reset-size11.size5,
  .katex .fontsize-ensurer.reset-size11.size5 {
    /* stylelint-disable-next-line */
    font-size: 0.3617363344em;
  }
  .katex .sizing.reset-size11.size6,
  .katex .fontsize-ensurer.reset-size11.size6 {
    /* stylelint-disable-next-line */
    font-size: 0.4019292605em;
  }
  .katex .sizing.reset-size11.size7,
  .katex .fontsize-ensurer.reset-size11.size7 {
    /* stylelint-disable-next-line */
    font-size: 0.4823151125em;
  }
  .katex .sizing.reset-size11.size8,
  .katex .fontsize-ensurer.reset-size11.size8 {
    /* stylelint-disable-next-line */
    font-size: 0.578778135em;
  }
  .katex .sizing.reset-size11.size9,
  .katex .fontsize-ensurer.reset-size11.size9 {
    /* stylelint-disable-next-line */
    font-size: 0.6945337621em;
  }
  .katex .sizing.reset-size11.size10,
  .katex .fontsize-ensurer.reset-size11.size10 {
    /* stylelint-disable-next-line */
    font-size: 0.8336012862em;
  }
  .katex .sizing.reset-size11.size11,
  .katex .fontsize-ensurer.reset-size11.size11 {
    /* stylelint-disable-next-line */
    font-size: 1em;
  }
  .katex .delimsizing.size1 {
    font-family: KaTeX_Size1;
  }
  .katex .delimsizing.size2 {
    font-family: KaTeX_Size2;
  }
  .katex .delimsizing.size3 {
    font-family: KaTeX_Size3;
  }
  .katex .delimsizing.size4 {
    font-family: KaTeX_Size4;
  }
  .katex .delimsizing.mult .delim-size1 > span {
    font-family: KaTeX_Size1;
  }
  .katex .delimsizing.mult .delim-size4 > span {
    font-family: KaTeX_Size4;
  }
  .katex .nulldelimiter {
    display: inline-block;
    width: 0.12em;
  }
  .katex .delimcenter {
    position: relative;
  }
  .katex .op-symbol {
    position: relative;
  }
  .katex .op-symbol.small-op {
    font-family: KaTeX_Size1;
  }
  .katex .op-symbol.large-op {
    font-family: KaTeX_Size2;
  }
  .katex .op-limits > .vlist-t {
    text-align: center;
  }
  .katex .accent > .vlist-t {
    text-align: center;
  }
  .katex .accent .accent-body {
    position: relative;
  }
  .katex .accent .accent-body:not(.accent-full) {
    width: 0;
  }
  .katex .overlay {
    display: block;
  }
  .katex .mtable .vertical-separator {
    display: inline-block;
    min-width: 1px;
  }
  .katex .mtable .arraycolsep {
    display: inline-block;
  }
  .katex .mtable .col-align-c > .vlist-t {
    text-align: center;
  }
  .katex .mtable .col-align-l > .vlist-t {
    text-align: left;
  }
  .katex .mtable .col-align-r > .vlist-t {
    text-align: right;
  }
  .katex .svg-align {
    text-align: left;
  }
  .katex svg {
    display: block;
    position: absolute;
    width: 100%;
    height: inherit;
    fill: currentColor;
    stroke: currentColor;
    fill-rule: nonzero;
    fill-opacity: 1;
    stroke-width: 1;
    stroke-linecap: butt;
    stroke-linejoin: miter;
    stroke-miterlimit: 4;
    stroke-dasharray: none;
    stroke-dashoffset: 0;
    stroke-opacity: 1;
  }
  .katex svg path {
    stroke: none;
  }
  .katex img {
    border-style: none;
    min-width: 0;
    min-height: 0;
    max-width: none;
    max-height: none;
  }
  .katex .stretchy {
    width: 100%;
    display: block;
    position: relative;
    overflow: hidden;
  }
  .katex .stretchy::before, .katex .stretchy::after {
    content: "";
  }
  .katex .hide-tail {
    width: 100%;
    position: relative;
    overflow: hidden;
  }
  .katex .halfarrow-left {
    position: absolute;
    left: 0;
    width: 50.2%;
    overflow: hidden;
  }
  .katex .halfarrow-right {
    position: absolute;
    right: 0;
    width: 50.2%;
    overflow: hidden;
  }
  .katex .brace-left {
    position: absolute;
    left: 0;
    width: 25.1%;
    overflow: hidden;
  }
  .katex .brace-center {
    position: absolute;
    left: 25%;
    width: 50%;
    overflow: hidden;
  }
  .katex .brace-right {
    position: absolute;
    right: 0;
    width: 25.1%;
    overflow: hidden;
  }
  .katex .x-arrow-pad {
    padding: 0 0.5em;
  }
  .katex .cd-arrow-pad {
    padding: 0 0.55556em 0 0.27778em;
  }
  .katex .x-arrow,
  .katex .mover,
  .katex .munder {
    text-align: center;
  }
  .katex .boxpad {
    padding: 0 0.3em;
  }
  .katex .fbox,
  .katex .fcolorbox {
    box-sizing: border-box;
    border: 0.04em solid;
  }
  .katex .cancel-pad {
    padding: 0 0.2em;
  }
  .katex .cancel-lap {
    margin-left: -0.2em;
    margin-right: -0.2em;
  }
  .katex .sout {
    border-bottom-style: solid;
    border-bottom-width: 0.08em;
  }
  .katex .angl {
    box-sizing: border-box;
    border-top: 0.049em solid;
    border-right: 0.049em solid;
    margin-right: 0.03889em;
  }
  .katex .anglpad {
    padding: 0 0.03889em;
  }
  .katex .eqn-num::before {
    counter-increment: katexEqnNo;
    content: "(" counter(katexEqnNo) ")";
  }
  .katex .mml-eqn-num::before {
    counter-increment: mmlEqnNo;
    content: "(" counter(mmlEqnNo) ")";
  }
  .katex .mtr-glue {
    width: 50%;
  }
  .katex .cd-vert-arrow {
    display: inline-block;
    position: relative;
  }
  .katex .cd-label-left {
    display: inline-block;
    position: absolute;
    right: calc(50% + 0.3em);
    text-align: left;
  }
  .katex .cd-label-right {
    display: inline-block;
    position: absolute;
    left: calc(50% + 0.3em);
    text-align: right;
  }
  
  .katex-display {
    display: block;
    margin: 1em 0;
    text-align: center;
  }
  .katex-display > .katex {
    display: block;
    text-align: center;
    white-space: nowrap;
  }
  .katex-display > .katex > .katex-html {
    display: block;
    position: relative;
  }
  .katex-display > .katex > .katex-html > .tag {
    position: absolute;
    right: 0;
  }
  
  .katex-display.leqno > .katex > .katex-html > .tag {
    left: 0;
    right: auto;
  }
  
  .katex-display.fleqn > .katex {
    text-align: left;
    padding-left: 2em;
  }
  
  body {
    counter-reset: katexEqnNo mmlEqnNo;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/styles/custom-katex.css"],"names":[],"mappings":"AAAA,oEAAoE;AACpE;IACI,wBAAwB;IACxB,gLAA8J;IAC9J,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,gCAAgC;IAChC,gLAA6K;IAC7K,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gCAAgC;IAChC,gLAAsL;IACtL,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,4BAA4B;IAC5B,kLAAiK;IACjK,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,4BAA4B;IAC5B,mLAA0K;IAC1K,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,yBAAyB;IACzB,mLAAwJ;IACxJ,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,yBAAyB;IACzB,mLAA0K;IAC1K,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,yBAAyB;IACzB,mLAA8J;IAC9J,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,yBAAyB;IACzB,mLAAiK;IACjK,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,yBAAyB;IACzB,mLAA0K;IAC1K,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,yBAAyB;IACzB,mLAA8J;IAC9J,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,8BAA8B;IAC9B,mLAAuK;IACvK,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,8BAA8B;IAC9B,mLAA6K;IAC7K,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,8BAA8B;IAC9B,mLAAgL;IAChL,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,2BAA2B;IAC3B,mLAAuK;IACvK,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,mLAAoK;IACpK,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,mLAAoK;IACpK,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,mLAAoK;IACpK,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,mLAAoK;IACpK,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,+BAA+B;IAC/B,mLAAmL;IACnL,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,sDAAsD;IACtD,gBAAgB;IAChB,cAAc;IACd,oBAAoB;EACtB;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,0BAA0B;IAC1B,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;EACA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;EACA;;IAEE,sBAAsB;EACxB;EACA;IACE,8BAA8B;EAChC;EACA;;IAEE,0BAA0B;EAC5B;EACA;;IAEE,0BAA0B;IAC1B,iBAAiB;EACnB;EACA;IACE,6BAA6B;EAC/B;EACA;;IAEE,yBAAyB;EAC3B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,4BAA4B;IAC5B,iBAAiB;EACnB;EACA;;IAEE,4BAA4B;IAC5B,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,SAAS;IACT,kBAAkB;EACpB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,QAAQ;EACV;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,UAAU;IACV,cAAc;EAChB;EACA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,WAAW;IACX,0BAA0B;EAC5B;EACA;;;;;;IAME,eAAe;EACjB;EACA;IACE,qBAAqB;EACvB;EACA;;;IAGE,QAAQ;IACR,kBAAkB;EACpB;EACA;;;IAGE,kBAAkB;EACpB;EACA;;;IAGE,qBAAqB;EACvB;EACA;IACE,QAAQ;EACV;EACA;;IAEE,OAAO;EACT;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,qBAAqB;IACrB,eAAe;IACf,kBAAkB;EACpB;EACA;;;IAGE,qBAAqB;IACrB,WAAW;IACX,0BAA0B;EAC5B;EACA;IACE,qBAAqB;IACrB,WAAW;IACX,2BAA2B;EAC7B;EACA;IACE;uCACmC;IACnC,2BAA2B;IAC3B,6BAA6B;EAC/B;EACA;;IAEE,gCAAgC;IAChC,cAAc;EAChB;EACA;;IAEE,gCAAgC;IAChC,gBAAgB;EAClB;EACA;;IAEE,gCAAgC;IAChC,gBAAgB;EAClB;EACA;;IAEE,gCAAgC;IAChC,gBAAgB;EAClB;EACA;;IAEE,gCAAgC;IAChC,gBAAgB;EAClB;EACA;;IAEE,gCAAgC;IAChC,cAAc;EAChB;EACA;;IAEE,gCAAgC;IAChC,gBAAgB;EAClB;EACA;;IAEE,gCAAgC;IAChC,iBAAiB;EACnB;EACA;;IAEE,gCAAgC;IAChC,kBAAkB;EACpB;EACA;;IAEE,gCAAgC;IAChC,kBAAkB;EACpB;EACA;;IAEE,gCAAgC;IAChC,kBAAkB;EACpB;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,cAAc;EAChB;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,gBAAgB;EAClB;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,cAAc;EAChB;EACA;;IAEE,gCAAgC;IAChC,gBAAgB;EAClB;EACA;;IAEE,gCAAgC;IAChC,iBAAiB;EACnB;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,cAAc;EAChB;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,kBAAkB;EACpB;EACA;;IAEE,gCAAgC;IAChC,iBAAiB;EACnB;EACA;;IAEE,gCAAgC;IAChC,kBAAkB;EACpB;EACA;;IAEE,gCAAgC;IAChC,cAAc;EAChB;EACA;;IAEE,gCAAgC;IAChC,kBAAkB;EACpB;EACA;;IAEE,gCAAgC;IAChC,iBAAiB;EACnB;EACA;;IAEE,gCAAgC;IAChC,gBAAgB;EAClB;EACA;;IAEE,gCAAgC;IAChC,gBAAgB;EAClB;EACA;;IAEE,gCAAgC;IAChC,iBAAiB;EACnB;EACA;;IAEE,gCAAgC;IAChC,mBAAmB;EACrB;EACA;;IAEE,gCAAgC;IAChC,iBAAiB;EACnB;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,cAAc;EAChB;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,gBAAgB;EAClB;EACA;;IAEE,gCAAgC;IAChC,iBAAiB;EACnB;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,gBAAgB;EAClB;EACA;;IAEE,gCAAgC;IAChC,gBAAgB;EAClB;EACA;;IAEE,gCAAgC;IAChC,gBAAgB;EAClB;EACA;;IAEE,gCAAgC;IAChC,gBAAgB;EAClB;EACA;;IAEE,gCAAgC;IAChC,gBAAgB;EAClB;EACA;;IAEE,gCAAgC;IAChC,cAAc;EAChB;EACA;;IAEE,gCAAgC;IAChC,gBAAgB;EAClB;EACA;;IAEE,gCAAgC;IAChC,iBAAiB;EACnB;EACA;;IAEE,gCAAgC;IAChC,kBAAkB;EACpB;EACA;;IAEE,gCAAgC;IAChC,kBAAkB;EACpB;EACA;;IAEE,gCAAgC;IAChC,kBAAkB;EACpB;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,gBAAgB;EAClB;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,iBAAiB;EACnB;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,cAAc;EAChB;EACA;;IAEE,gCAAgC;IAChC,gBAAgB;EAClB;EACA;;IAEE,gCAAgC;IAChC,iBAAiB;EACnB;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,kBAAkB;EACpB;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,cAAc;EAChB;EACA;;IAEE,gCAAgC;IAChC,gBAAgB;EAClB;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,wBAAwB;EAC1B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,cAAc;EAChB;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,wBAAwB;EAC1B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,cAAc;EAChB;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,wBAAwB;EAC1B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;;IAEE,gCAAgC;IAChC,cAAc;EAChB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,qBAAqB;IACrB,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;EAChB;EACA;IACE,qBAAqB;IACrB,cAAc;EAChB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,oBAAoB;IACpB,sBAAsB;IACtB,oBAAoB;IACpB,sBAAsB;IACtB,oBAAoB;IACpB,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gCAAgC;EAClC;EACA;;;IAGE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;;IAEE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,sBAAsB;IACtB,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,6BAA6B;IAC7B,oCAAoC;EACtC;EACA;IACE,2BAA2B;IAC3B,kCAAkC;EACpC;EACA;IACE,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,OAAO;IACP,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,kCAAkC;EACpC","sourcesContent":["/* stylelint-disable font-family-no-missing-generic-family-keyword */\n@font-face {\n    font-family: \"KaTeX_AMS\";\n    src: url(fonts/KaTeX_AMS-Regular.woff2) format(\"woff2\"), url(fonts/KaTeX_AMS-Regular.woff) format(\"woff\"), url(fonts/KaTeX_AMS-Regular.ttf) format(\"truetype\");\n    font-weight: normal;\n    font-style: normal;\n  }\n  @font-face {\n    font-family: \"KaTeX_Caligraphic\";\n    src: url(fonts/KaTeX_Caligraphic-Bold.woff2) format(\"woff2\"), url(fonts/KaTeX_Caligraphic-Bold.woff) format(\"woff\"), url(fonts/KaTeX_Caligraphic-Bold.ttf) format(\"truetype\");\n    font-weight: bold;\n    font-style: normal;\n  }\n  @font-face {\n    font-family: \"KaTeX_Caligraphic\";\n    src: url(fonts/KaTeX_Caligraphic-Regular.woff2) format(\"woff2\"), url(fonts/KaTeX_Caligraphic-Regular.woff) format(\"woff\"), url(fonts/KaTeX_Caligraphic-Regular.ttf) format(\"truetype\");\n    font-weight: normal;\n    font-style: normal;\n  }\n  @font-face {\n    font-family: \"KaTeX_Fraktur\";\n    src: url(fonts/KaTeX_Fraktur-Bold.woff2) format(\"woff2\"), url(fonts/KaTeX_Fraktur-Bold.woff) format(\"woff\"), url(fonts/KaTeX_Fraktur-Bold.ttf) format(\"truetype\");\n    font-weight: bold;\n    font-style: normal;\n  }\n  @font-face {\n    font-family: \"KaTeX_Fraktur\";\n    src: url(fonts/KaTeX_Fraktur-Regular.woff2) format(\"woff2\"), url(fonts/KaTeX_Fraktur-Regular.woff) format(\"woff\"), url(fonts/KaTeX_Fraktur-Regular.ttf) format(\"truetype\");\n    font-weight: normal;\n    font-style: normal;\n  }\n  @font-face {\n    font-family: \"KaTeX_Main\";\n    src: url(fonts/KaTeX_Main-Bold.woff2) format(\"woff2\"), url(fonts/KaTeX_Main-Bold.woff) format(\"woff\"), url(fonts/KaTeX_Main-Bold.ttf) format(\"truetype\");\n    font-weight: bold;\n    font-style: normal;\n  }\n  @font-face {\n    font-family: \"KaTeX_Main\";\n    src: url(fonts/KaTeX_Main-BoldItalic.woff2) format(\"woff2\"), url(fonts/KaTeX_Main-BoldItalic.woff) format(\"woff\"), url(fonts/KaTeX_Main-BoldItalic.ttf) format(\"truetype\");\n    font-weight: bold;\n    font-style: italic;\n  }\n  @font-face {\n    font-family: \"KaTeX_Main\";\n    src: url(fonts/KaTeX_Main-Italic.woff2) format(\"woff2\"), url(fonts/KaTeX_Main-Italic.woff) format(\"woff\"), url(fonts/KaTeX_Main-Italic.ttf) format(\"truetype\");\n    font-weight: normal;\n    font-style: italic;\n  }\n  @font-face {\n    font-family: \"KaTeX_Main\";\n    src: url(fonts/KaTeX_Main-Regular.woff2) format(\"woff2\"), url(fonts/KaTeX_Main-Regular.woff) format(\"woff\"), url(fonts/KaTeX_Main-Regular.ttf) format(\"truetype\");\n    font-weight: normal;\n    font-style: normal;\n  }\n  @font-face {\n    font-family: \"KaTeX_Math\";\n    src: url(fonts/KaTeX_Math-BoldItalic.woff2) format(\"woff2\"), url(fonts/KaTeX_Math-BoldItalic.woff) format(\"woff\"), url(fonts/KaTeX_Math-BoldItalic.ttf) format(\"truetype\");\n    font-weight: bold;\n    font-style: italic;\n  }\n  @font-face {\n    font-family: \"KaTeX_Math\";\n    src: url(fonts/KaTeX_Math-Italic.woff2) format(\"woff2\"), url(fonts/KaTeX_Math-Italic.woff) format(\"woff\"), url(fonts/KaTeX_Math-Italic.ttf) format(\"truetype\");\n    font-weight: normal;\n    font-style: italic;\n  }\n  @font-face {\n    font-family: \"KaTeX_SansSerif\";\n    src: url(fonts/KaTeX_SansSerif-Bold.woff2) format(\"woff2\"), url(fonts/KaTeX_SansSerif-Bold.woff) format(\"woff\"), url(fonts/KaTeX_SansSerif-Bold.ttf) format(\"truetype\");\n    font-weight: bold;\n    font-style: normal;\n  }\n  @font-face {\n    font-family: \"KaTeX_SansSerif\";\n    src: url(fonts/KaTeX_SansSerif-Italic.woff2) format(\"woff2\"), url(fonts/KaTeX_SansSerif-Italic.woff) format(\"woff\"), url(fonts/KaTeX_SansSerif-Italic.ttf) format(\"truetype\");\n    font-weight: normal;\n    font-style: italic;\n  }\n  @font-face {\n    font-family: \"KaTeX_SansSerif\";\n    src: url(fonts/KaTeX_SansSerif-Regular.woff2) format(\"woff2\"), url(fonts/KaTeX_SansSerif-Regular.woff) format(\"woff\"), url(fonts/KaTeX_SansSerif-Regular.ttf) format(\"truetype\");\n    font-weight: normal;\n    font-style: normal;\n  }\n  @font-face {\n    font-family: \"KaTeX_Script\";\n    src: url(fonts/KaTeX_Script-Regular.woff2) format(\"woff2\"), url(fonts/KaTeX_Script-Regular.woff) format(\"woff\"), url(fonts/KaTeX_Script-Regular.ttf) format(\"truetype\");\n    font-weight: normal;\n    font-style: normal;\n  }\n  @font-face {\n    font-family: \"KaTeX_Size1\";\n    src: url(fonts/KaTeX_Size1-Regular.woff2) format(\"woff2\"), url(fonts/KaTeX_Size1-Regular.woff) format(\"woff\"), url(fonts/KaTeX_Size1-Regular.ttf) format(\"truetype\");\n    font-weight: normal;\n    font-style: normal;\n  }\n  @font-face {\n    font-family: \"KaTeX_Size2\";\n    src: url(fonts/KaTeX_Size2-Regular.woff2) format(\"woff2\"), url(fonts/KaTeX_Size2-Regular.woff) format(\"woff\"), url(fonts/KaTeX_Size2-Regular.ttf) format(\"truetype\");\n    font-weight: normal;\n    font-style: normal;\n  }\n  @font-face {\n    font-family: \"KaTeX_Size3\";\n    src: url(fonts/KaTeX_Size3-Regular.woff2) format(\"woff2\"), url(fonts/KaTeX_Size3-Regular.woff) format(\"woff\"), url(fonts/KaTeX_Size3-Regular.ttf) format(\"truetype\");\n    font-weight: normal;\n    font-style: normal;\n  }\n  @font-face {\n    font-family: \"KaTeX_Size4\";\n    src: url(fonts/KaTeX_Size4-Regular.woff2) format(\"woff2\"), url(fonts/KaTeX_Size4-Regular.woff) format(\"woff\"), url(fonts/KaTeX_Size4-Regular.ttf) format(\"truetype\");\n    font-weight: normal;\n    font-style: normal;\n  }\n  @font-face {\n    font-family: \"KaTeX_Typewriter\";\n    src: url(fonts/KaTeX_Typewriter-Regular.woff2) format(\"woff2\"), url(fonts/KaTeX_Typewriter-Regular.woff) format(\"woff\"), url(fonts/KaTeX_Typewriter-Regular.ttf) format(\"truetype\");\n    font-weight: normal;\n    font-style: normal;\n  }\n  .katex {\n    font: normal 1.21em KaTeX_Main, Times New Roman, serif;\n    line-height: 1.2;\n    text-indent: 0;\n    text-rendering: auto;\n  }\n  .katex * {\n    -ms-high-contrast-adjust: none !important;\n  }\n  .katex * {\n    border-color: currentColor;\n  }\n  .katex .katex-version::after {\n    content: \"0.16.11\";\n  }\n\n  .katex .katex-html > .newline {\n    display: block;\n  }\n  .katex .base {\n    position: relative;\n    display: inline-block;\n    white-space: nowrap;\n    width: -webkit-min-content;\n    width: -moz-min-content;\n    width: min-content;\n  }\n  .katex .strut {\n    display: inline-block;\n  }\n  .katex .textbf {\n    font-weight: bold;\n  }\n  .katex .textit {\n    font-style: italic;\n  }\n  .katex .textrm {\n    font-family: KaTeX_Main;\n  }\n  .katex .textsf {\n    font-family: KaTeX_SansSerif;\n  }\n  .katex .texttt {\n    font-family: KaTeX_Typewriter;\n  }\n  .katex .mathnormal {\n    font-family: KaTeX_Math;\n    font-style: italic;\n  }\n  .katex .mathit {\n    font-family: KaTeX_Main;\n    font-style: italic;\n  }\n  .katex .mathrm {\n    font-style: normal;\n  }\n  .katex .mathbf {\n    font-family: KaTeX_Main;\n    font-weight: bold;\n  }\n  .katex .boldsymbol {\n    font-family: KaTeX_Math;\n    font-weight: bold;\n    font-style: italic;\n  }\n  .katex .amsrm {\n    font-family: KaTeX_AMS;\n  }\n  .katex .mathbb,\n  .katex .textbb {\n    font-family: KaTeX_AMS;\n  }\n  .katex .mathcal {\n    font-family: KaTeX_Caligraphic;\n  }\n  .katex .mathfrak,\n  .katex .textfrak {\n    font-family: KaTeX_Fraktur;\n  }\n  .katex .mathboldfrak,\n  .katex .textboldfrak {\n    font-family: KaTeX_Fraktur;\n    font-weight: bold;\n  }\n  .katex .mathtt {\n    font-family: KaTeX_Typewriter;\n  }\n  .katex .mathscr,\n  .katex .textscr {\n    font-family: KaTeX_Script;\n  }\n  .katex .mathsf,\n  .katex .textsf {\n    font-family: KaTeX_SansSerif;\n  }\n  .katex .mathboldsf,\n  .katex .textboldsf {\n    font-family: KaTeX_SansSerif;\n    font-weight: bold;\n  }\n  .katex .mathitsf,\n  .katex .textitsf {\n    font-family: KaTeX_SansSerif;\n    font-style: italic;\n  }\n  .katex .mainrm {\n    font-family: KaTeX_Main;\n    font-style: normal;\n  }\n  .katex .vlist-t {\n    display: inline-table;\n    table-layout: fixed;\n    border-collapse: collapse;\n  }\n  .katex .vlist-r {\n    display: table-row;\n  }\n  .katex .vlist {\n    display: table-cell;\n    vertical-align: bottom;\n    position: relative;\n  }\n  .katex .vlist > span {\n    display: block;\n    height: 0;\n    position: relative;\n  }\n  .katex .vlist > span > span {\n    display: inline-block;\n  }\n  .katex .vlist > span > .pstrut {\n    overflow: hidden;\n    width: 0;\n  }\n  .katex .vlist-t2 {\n    margin-right: -2px;\n  }\n  .katex .vlist-s {\n    display: table-cell;\n    vertical-align: bottom;\n    font-size: 1px;\n    width: 2px;\n    min-width: 2px;\n  }\n  .katex .vbox {\n    display: inline-flex;\n    flex-direction: column;\n    align-items: baseline;\n  }\n  .katex .hbox {\n    display: inline-flex;\n    flex-direction: row;\n    width: 100%;\n  }\n  .katex .thinbox {\n    display: inline-flex;\n    flex-direction: row;\n    width: 0;\n    max-width: 0;\n  }\n  .katex .msupsub {\n    text-align: left;\n  }\n  .katex .mfrac > span > span {\n    text-align: center;\n  }\n  .katex .mfrac .frac-line {\n    display: inline-block;\n    width: 100%;\n    border-bottom-style: solid;\n  }\n  .katex .mfrac .frac-line,\n  .katex .overline .overline-line,\n  .katex .underline .underline-line,\n  .katex .hline,\n  .katex .hdashline,\n  .katex .rule {\n    min-height: 1px;\n  }\n  .katex .mspace {\n    display: inline-block;\n  }\n  .katex .llap,\n  .katex .rlap,\n  .katex .clap {\n    width: 0;\n    position: relative;\n  }\n  .katex .llap > .inner,\n  .katex .rlap > .inner,\n  .katex .clap > .inner {\n    position: absolute;\n  }\n  .katex .llap > .fix,\n  .katex .rlap > .fix,\n  .katex .clap > .fix {\n    display: inline-block;\n  }\n  .katex .llap > .inner {\n    right: 0;\n  }\n  .katex .rlap > .inner,\n  .katex .clap > .inner {\n    left: 0;\n  }\n  .katex .clap > .inner > span {\n    margin-left: -50%;\n    margin-right: 50%;\n  }\n  .katex .rule {\n    display: inline-block;\n    border: solid 0;\n    position: relative;\n  }\n  .katex .overline .overline-line,\n  .katex .underline .underline-line,\n  .katex .hline {\n    display: inline-block;\n    width: 100%;\n    border-bottom-style: solid;\n  }\n  .katex .hdashline {\n    display: inline-block;\n    width: 100%;\n    border-bottom-style: dashed;\n  }\n  .katex .sqrt > .root {\n    /* These values are taken from the definition of `\\r@@t`,\n     `\\mkern 5mu` and `\\mkern -10mu`. */\n    margin-left: 0.2777777778em;\n    margin-right: -0.5555555556em;\n  }\n  .katex .sizing.reset-size1.size1,\n  .katex .fontsize-ensurer.reset-size1.size1 {\n    /* stylelint-disable-next-line */\n    font-size: 1em;\n  }\n  .katex .sizing.reset-size1.size2,\n  .katex .fontsize-ensurer.reset-size1.size2 {\n    /* stylelint-disable-next-line */\n    font-size: 1.2em;\n  }\n  .katex .sizing.reset-size1.size3,\n  .katex .fontsize-ensurer.reset-size1.size3 {\n    /* stylelint-disable-next-line */\n    font-size: 1.4em;\n  }\n  .katex .sizing.reset-size1.size4,\n  .katex .fontsize-ensurer.reset-size1.size4 {\n    /* stylelint-disable-next-line */\n    font-size: 1.6em;\n  }\n  .katex .sizing.reset-size1.size5,\n  .katex .fontsize-ensurer.reset-size1.size5 {\n    /* stylelint-disable-next-line */\n    font-size: 1.8em;\n  }\n  .katex .sizing.reset-size1.size6,\n  .katex .fontsize-ensurer.reset-size1.size6 {\n    /* stylelint-disable-next-line */\n    font-size: 2em;\n  }\n  .katex .sizing.reset-size1.size7,\n  .katex .fontsize-ensurer.reset-size1.size7 {\n    /* stylelint-disable-next-line */\n    font-size: 2.4em;\n  }\n  .katex .sizing.reset-size1.size8,\n  .katex .fontsize-ensurer.reset-size1.size8 {\n    /* stylelint-disable-next-line */\n    font-size: 2.88em;\n  }\n  .katex .sizing.reset-size1.size9,\n  .katex .fontsize-ensurer.reset-size1.size9 {\n    /* stylelint-disable-next-line */\n    font-size: 3.456em;\n  }\n  .katex .sizing.reset-size1.size10,\n  .katex .fontsize-ensurer.reset-size1.size10 {\n    /* stylelint-disable-next-line */\n    font-size: 4.148em;\n  }\n  .katex .sizing.reset-size1.size11,\n  .katex .fontsize-ensurer.reset-size1.size11 {\n    /* stylelint-disable-next-line */\n    font-size: 4.976em;\n  }\n  .katex .sizing.reset-size2.size1,\n  .katex .fontsize-ensurer.reset-size2.size1 {\n    /* stylelint-disable-next-line */\n    font-size: 0.8333333333em;\n  }\n  .katex .sizing.reset-size2.size2,\n  .katex .fontsize-ensurer.reset-size2.size2 {\n    /* stylelint-disable-next-line */\n    font-size: 1em;\n  }\n  .katex .sizing.reset-size2.size3,\n  .katex .fontsize-ensurer.reset-size2.size3 {\n    /* stylelint-disable-next-line */\n    font-size: 1.1666666667em;\n  }\n  .katex .sizing.reset-size2.size4,\n  .katex .fontsize-ensurer.reset-size2.size4 {\n    /* stylelint-disable-next-line */\n    font-size: 1.3333333333em;\n  }\n  .katex .sizing.reset-size2.size5,\n  .katex .fontsize-ensurer.reset-size2.size5 {\n    /* stylelint-disable-next-line */\n    font-size: 1.5em;\n  }\n  .katex .sizing.reset-size2.size6,\n  .katex .fontsize-ensurer.reset-size2.size6 {\n    /* stylelint-disable-next-line */\n    font-size: 1.6666666667em;\n  }\n  .katex .sizing.reset-size2.size7,\n  .katex .fontsize-ensurer.reset-size2.size7 {\n    /* stylelint-disable-next-line */\n    font-size: 2em;\n  }\n  .katex .sizing.reset-size2.size8,\n  .katex .fontsize-ensurer.reset-size2.size8 {\n    /* stylelint-disable-next-line */\n    font-size: 2.4em;\n  }\n  .katex .sizing.reset-size2.size9,\n  .katex .fontsize-ensurer.reset-size2.size9 {\n    /* stylelint-disable-next-line */\n    font-size: 2.88em;\n  }\n  .katex .sizing.reset-size2.size10,\n  .katex .fontsize-ensurer.reset-size2.size10 {\n    /* stylelint-disable-next-line */\n    font-size: 3.4566666667em;\n  }\n  .katex .sizing.reset-size2.size11,\n  .katex .fontsize-ensurer.reset-size2.size11 {\n    /* stylelint-disable-next-line */\n    font-size: 4.1466666667em;\n  }\n  .katex .sizing.reset-size3.size1,\n  .katex .fontsize-ensurer.reset-size3.size1 {\n    /* stylelint-disable-next-line */\n    font-size: 0.7142857143em;\n  }\n  .katex .sizing.reset-size3.size2,\n  .katex .fontsize-ensurer.reset-size3.size2 {\n    /* stylelint-disable-next-line */\n    font-size: 0.8571428571em;\n  }\n  .katex .sizing.reset-size3.size3,\n  .katex .fontsize-ensurer.reset-size3.size3 {\n    /* stylelint-disable-next-line */\n    font-size: 1em;\n  }\n  .katex .sizing.reset-size3.size4,\n  .katex .fontsize-ensurer.reset-size3.size4 {\n    /* stylelint-disable-next-line */\n    font-size: 1.1428571429em;\n  }\n  .katex .sizing.reset-size3.size5,\n  .katex .fontsize-ensurer.reset-size3.size5 {\n    /* stylelint-disable-next-line */\n    font-size: 1.2857142857em;\n  }\n  .katex .sizing.reset-size3.size6,\n  .katex .fontsize-ensurer.reset-size3.size6 {\n    /* stylelint-disable-next-line */\n    font-size: 1.4285714286em;\n  }\n  .katex .sizing.reset-size3.size7,\n  .katex .fontsize-ensurer.reset-size3.size7 {\n    /* stylelint-disable-next-line */\n    font-size: 1.7142857143em;\n  }\n  .katex .sizing.reset-size3.size8,\n  .katex .fontsize-ensurer.reset-size3.size8 {\n    /* stylelint-disable-next-line */\n    font-size: 2.0571428571em;\n  }\n  .katex .sizing.reset-size3.size9,\n  .katex .fontsize-ensurer.reset-size3.size9 {\n    /* stylelint-disable-next-line */\n    font-size: 2.4685714286em;\n  }\n  .katex .sizing.reset-size3.size10,\n  .katex .fontsize-ensurer.reset-size3.size10 {\n    /* stylelint-disable-next-line */\n    font-size: 2.9628571429em;\n  }\n  .katex .sizing.reset-size3.size11,\n  .katex .fontsize-ensurer.reset-size3.size11 {\n    /* stylelint-disable-next-line */\n    font-size: 3.5542857143em;\n  }\n  .katex .sizing.reset-size4.size1,\n  .katex .fontsize-ensurer.reset-size4.size1 {\n    /* stylelint-disable-next-line */\n    font-size: 0.625em;\n  }\n  .katex .sizing.reset-size4.size2,\n  .katex .fontsize-ensurer.reset-size4.size2 {\n    /* stylelint-disable-next-line */\n    font-size: 0.75em;\n  }\n  .katex .sizing.reset-size4.size3,\n  .katex .fontsize-ensurer.reset-size4.size3 {\n    /* stylelint-disable-next-line */\n    font-size: 0.875em;\n  }\n  .katex .sizing.reset-size4.size4,\n  .katex .fontsize-ensurer.reset-size4.size4 {\n    /* stylelint-disable-next-line */\n    font-size: 1em;\n  }\n  .katex .sizing.reset-size4.size5,\n  .katex .fontsize-ensurer.reset-size4.size5 {\n    /* stylelint-disable-next-line */\n    font-size: 1.125em;\n  }\n  .katex .sizing.reset-size4.size6,\n  .katex .fontsize-ensurer.reset-size4.size6 {\n    /* stylelint-disable-next-line */\n    font-size: 1.25em;\n  }\n  .katex .sizing.reset-size4.size7,\n  .katex .fontsize-ensurer.reset-size4.size7 {\n    /* stylelint-disable-next-line */\n    font-size: 1.5em;\n  }\n  .katex .sizing.reset-size4.size8,\n  .katex .fontsize-ensurer.reset-size4.size8 {\n    /* stylelint-disable-next-line */\n    font-size: 1.8em;\n  }\n  .katex .sizing.reset-size4.size9,\n  .katex .fontsize-ensurer.reset-size4.size9 {\n    /* stylelint-disable-next-line */\n    font-size: 2.16em;\n  }\n  .katex .sizing.reset-size4.size10,\n  .katex .fontsize-ensurer.reset-size4.size10 {\n    /* stylelint-disable-next-line */\n    font-size: 2.5925em;\n  }\n  .katex .sizing.reset-size4.size11,\n  .katex .fontsize-ensurer.reset-size4.size11 {\n    /* stylelint-disable-next-line */\n    font-size: 3.11em;\n  }\n  .katex .sizing.reset-size5.size1,\n  .katex .fontsize-ensurer.reset-size5.size1 {\n    /* stylelint-disable-next-line */\n    font-size: 0.5555555556em;\n  }\n  .katex .sizing.reset-size5.size2,\n  .katex .fontsize-ensurer.reset-size5.size2 {\n    /* stylelint-disable-next-line */\n    font-size: 0.6666666667em;\n  }\n  .katex .sizing.reset-size5.size3,\n  .katex .fontsize-ensurer.reset-size5.size3 {\n    /* stylelint-disable-next-line */\n    font-size: 0.7777777778em;\n  }\n  .katex .sizing.reset-size5.size4,\n  .katex .fontsize-ensurer.reset-size5.size4 {\n    /* stylelint-disable-next-line */\n    font-size: 0.8888888889em;\n  }\n  .katex .sizing.reset-size5.size5,\n  .katex .fontsize-ensurer.reset-size5.size5 {\n    /* stylelint-disable-next-line */\n    font-size: 1em;\n  }\n  .katex .sizing.reset-size5.size6,\n  .katex .fontsize-ensurer.reset-size5.size6 {\n    /* stylelint-disable-next-line */\n    font-size: 1.1111111111em;\n  }\n  .katex .sizing.reset-size5.size7,\n  .katex .fontsize-ensurer.reset-size5.size7 {\n    /* stylelint-disable-next-line */\n    font-size: 1.3333333333em;\n  }\n  .katex .sizing.reset-size5.size8,\n  .katex .fontsize-ensurer.reset-size5.size8 {\n    /* stylelint-disable-next-line */\n    font-size: 1.6em;\n  }\n  .katex .sizing.reset-size5.size9,\n  .katex .fontsize-ensurer.reset-size5.size9 {\n    /* stylelint-disable-next-line */\n    font-size: 1.92em;\n  }\n  .katex .sizing.reset-size5.size10,\n  .katex .fontsize-ensurer.reset-size5.size10 {\n    /* stylelint-disable-next-line */\n    font-size: 2.3044444444em;\n  }\n  .katex .sizing.reset-size5.size11,\n  .katex .fontsize-ensurer.reset-size5.size11 {\n    /* stylelint-disable-next-line */\n    font-size: 2.7644444444em;\n  }\n  .katex .sizing.reset-size6.size1,\n  .katex .fontsize-ensurer.reset-size6.size1 {\n    /* stylelint-disable-next-line */\n    font-size: 0.5em;\n  }\n  .katex .sizing.reset-size6.size2,\n  .katex .fontsize-ensurer.reset-size6.size2 {\n    /* stylelint-disable-next-line */\n    font-size: 0.6em;\n  }\n  .katex .sizing.reset-size6.size3,\n  .katex .fontsize-ensurer.reset-size6.size3 {\n    /* stylelint-disable-next-line */\n    font-size: 0.7em;\n  }\n  .katex .sizing.reset-size6.size4,\n  .katex .fontsize-ensurer.reset-size6.size4 {\n    /* stylelint-disable-next-line */\n    font-size: 0.8em;\n  }\n  .katex .sizing.reset-size6.size5,\n  .katex .fontsize-ensurer.reset-size6.size5 {\n    /* stylelint-disable-next-line */\n    font-size: 0.9em;\n  }\n  .katex .sizing.reset-size6.size6,\n  .katex .fontsize-ensurer.reset-size6.size6 {\n    /* stylelint-disable-next-line */\n    font-size: 1em;\n  }\n  .katex .sizing.reset-size6.size7,\n  .katex .fontsize-ensurer.reset-size6.size7 {\n    /* stylelint-disable-next-line */\n    font-size: 1.2em;\n  }\n  .katex .sizing.reset-size6.size8,\n  .katex .fontsize-ensurer.reset-size6.size8 {\n    /* stylelint-disable-next-line */\n    font-size: 1.44em;\n  }\n  .katex .sizing.reset-size6.size9,\n  .katex .fontsize-ensurer.reset-size6.size9 {\n    /* stylelint-disable-next-line */\n    font-size: 1.728em;\n  }\n  .katex .sizing.reset-size6.size10,\n  .katex .fontsize-ensurer.reset-size6.size10 {\n    /* stylelint-disable-next-line */\n    font-size: 2.074em;\n  }\n  .katex .sizing.reset-size6.size11,\n  .katex .fontsize-ensurer.reset-size6.size11 {\n    /* stylelint-disable-next-line */\n    font-size: 2.488em;\n  }\n  .katex .sizing.reset-size7.size1,\n  .katex .fontsize-ensurer.reset-size7.size1 {\n    /* stylelint-disable-next-line */\n    font-size: 0.4166666667em;\n  }\n  .katex .sizing.reset-size7.size2,\n  .katex .fontsize-ensurer.reset-size7.size2 {\n    /* stylelint-disable-next-line */\n    font-size: 0.5em;\n  }\n  .katex .sizing.reset-size7.size3,\n  .katex .fontsize-ensurer.reset-size7.size3 {\n    /* stylelint-disable-next-line */\n    font-size: 0.5833333333em;\n  }\n  .katex .sizing.reset-size7.size4,\n  .katex .fontsize-ensurer.reset-size7.size4 {\n    /* stylelint-disable-next-line */\n    font-size: 0.6666666667em;\n  }\n  .katex .sizing.reset-size7.size5,\n  .katex .fontsize-ensurer.reset-size7.size5 {\n    /* stylelint-disable-next-line */\n    font-size: 0.75em;\n  }\n  .katex .sizing.reset-size7.size6,\n  .katex .fontsize-ensurer.reset-size7.size6 {\n    /* stylelint-disable-next-line */\n    font-size: 0.8333333333em;\n  }\n  .katex .sizing.reset-size7.size7,\n  .katex .fontsize-ensurer.reset-size7.size7 {\n    /* stylelint-disable-next-line */\n    font-size: 1em;\n  }\n  .katex .sizing.reset-size7.size8,\n  .katex .fontsize-ensurer.reset-size7.size8 {\n    /* stylelint-disable-next-line */\n    font-size: 1.2em;\n  }\n  .katex .sizing.reset-size7.size9,\n  .katex .fontsize-ensurer.reset-size7.size9 {\n    /* stylelint-disable-next-line */\n    font-size: 1.44em;\n  }\n  .katex .sizing.reset-size7.size10,\n  .katex .fontsize-ensurer.reset-size7.size10 {\n    /* stylelint-disable-next-line */\n    font-size: 1.7283333333em;\n  }\n  .katex .sizing.reset-size7.size11,\n  .katex .fontsize-ensurer.reset-size7.size11 {\n    /* stylelint-disable-next-line */\n    font-size: 2.0733333333em;\n  }\n  .katex .sizing.reset-size8.size1,\n  .katex .fontsize-ensurer.reset-size8.size1 {\n    /* stylelint-disable-next-line */\n    font-size: 0.3472222222em;\n  }\n  .katex .sizing.reset-size8.size2,\n  .katex .fontsize-ensurer.reset-size8.size2 {\n    /* stylelint-disable-next-line */\n    font-size: 0.4166666667em;\n  }\n  .katex .sizing.reset-size8.size3,\n  .katex .fontsize-ensurer.reset-size8.size3 {\n    /* stylelint-disable-next-line */\n    font-size: 0.4861111111em;\n  }\n  .katex .sizing.reset-size8.size4,\n  .katex .fontsize-ensurer.reset-size8.size4 {\n    /* stylelint-disable-next-line */\n    font-size: 0.5555555556em;\n  }\n  .katex .sizing.reset-size8.size5,\n  .katex .fontsize-ensurer.reset-size8.size5 {\n    /* stylelint-disable-next-line */\n    font-size: 0.625em;\n  }\n  .katex .sizing.reset-size8.size6,\n  .katex .fontsize-ensurer.reset-size8.size6 {\n    /* stylelint-disable-next-line */\n    font-size: 0.6944444444em;\n  }\n  .katex .sizing.reset-size8.size7,\n  .katex .fontsize-ensurer.reset-size8.size7 {\n    /* stylelint-disable-next-line */\n    font-size: 0.8333333333em;\n  }\n  .katex .sizing.reset-size8.size8,\n  .katex .fontsize-ensurer.reset-size8.size8 {\n    /* stylelint-disable-next-line */\n    font-size: 1em;\n  }\n  .katex .sizing.reset-size8.size9,\n  .katex .fontsize-ensurer.reset-size8.size9 {\n    /* stylelint-disable-next-line */\n    font-size: 1.2em;\n  }\n  .katex .sizing.reset-size8.size10,\n  .katex .fontsize-ensurer.reset-size8.size10 {\n    /* stylelint-disable-next-line */\n    font-size: 1.4402777778em;\n  }\n  .katex .sizing.reset-size8.size11,\n  .katex .fontsize-ensurer.reset-size8.size11 {\n    /* stylelint-disable-next-line */\n    font-size: 1.7277777778em;\n  }\n  .katex .sizing.reset-size9.size1,\n  .katex .fontsize-ensurer.reset-size9.size1 {\n    /* stylelint-disable-next-line */\n    font-size: 0.2893518519em;\n  }\n  .katex .sizing.reset-size9.size2,\n  .katex .fontsize-ensurer.reset-size9.size2 {\n    /* stylelint-disable-next-line */\n    font-size: 0.3472222222em;\n  }\n  .katex .sizing.reset-size9.size3,\n  .katex .fontsize-ensurer.reset-size9.size3 {\n    /* stylelint-disable-next-line */\n    font-size: 0.4050925926em;\n  }\n  .katex .sizing.reset-size9.size4,\n  .katex .fontsize-ensurer.reset-size9.size4 {\n    /* stylelint-disable-next-line */\n    font-size: 0.462962963em;\n  }\n  .katex .sizing.reset-size9.size5,\n  .katex .fontsize-ensurer.reset-size9.size5 {\n    /* stylelint-disable-next-line */\n    font-size: 0.5208333333em;\n  }\n  .katex .sizing.reset-size9.size6,\n  .katex .fontsize-ensurer.reset-size9.size6 {\n    /* stylelint-disable-next-line */\n    font-size: 0.5787037037em;\n  }\n  .katex .sizing.reset-size9.size7,\n  .katex .fontsize-ensurer.reset-size9.size7 {\n    /* stylelint-disable-next-line */\n    font-size: 0.6944444444em;\n  }\n  .katex .sizing.reset-size9.size8,\n  .katex .fontsize-ensurer.reset-size9.size8 {\n    /* stylelint-disable-next-line */\n    font-size: 0.8333333333em;\n  }\n  .katex .sizing.reset-size9.size9,\n  .katex .fontsize-ensurer.reset-size9.size9 {\n    /* stylelint-disable-next-line */\n    font-size: 1em;\n  }\n  .katex .sizing.reset-size9.size10,\n  .katex .fontsize-ensurer.reset-size9.size10 {\n    /* stylelint-disable-next-line */\n    font-size: 1.2002314815em;\n  }\n  .katex .sizing.reset-size9.size11,\n  .katex .fontsize-ensurer.reset-size9.size11 {\n    /* stylelint-disable-next-line */\n    font-size: 1.4398148148em;\n  }\n  .katex .sizing.reset-size10.size1,\n  .katex .fontsize-ensurer.reset-size10.size1 {\n    /* stylelint-disable-next-line */\n    font-size: 0.2410800386em;\n  }\n  .katex .sizing.reset-size10.size2,\n  .katex .fontsize-ensurer.reset-size10.size2 {\n    /* stylelint-disable-next-line */\n    font-size: 0.2892960463em;\n  }\n  .katex .sizing.reset-size10.size3,\n  .katex .fontsize-ensurer.reset-size10.size3 {\n    /* stylelint-disable-next-line */\n    font-size: 0.337512054em;\n  }\n  .katex .sizing.reset-size10.size4,\n  .katex .fontsize-ensurer.reset-size10.size4 {\n    /* stylelint-disable-next-line */\n    font-size: 0.3857280617em;\n  }\n  .katex .sizing.reset-size10.size5,\n  .katex .fontsize-ensurer.reset-size10.size5 {\n    /* stylelint-disable-next-line */\n    font-size: 0.4339440694em;\n  }\n  .katex .sizing.reset-size10.size6,\n  .katex .fontsize-ensurer.reset-size10.size6 {\n    /* stylelint-disable-next-line */\n    font-size: 0.4821600771em;\n  }\n  .katex .sizing.reset-size10.size7,\n  .katex .fontsize-ensurer.reset-size10.size7 {\n    /* stylelint-disable-next-line */\n    font-size: 0.5785920926em;\n  }\n  .katex .sizing.reset-size10.size8,\n  .katex .fontsize-ensurer.reset-size10.size8 {\n    /* stylelint-disable-next-line */\n    font-size: 0.6943105111em;\n  }\n  .katex .sizing.reset-size10.size9,\n  .katex .fontsize-ensurer.reset-size10.size9 {\n    /* stylelint-disable-next-line */\n    font-size: 0.8331726133em;\n  }\n  .katex .sizing.reset-size10.size10,\n  .katex .fontsize-ensurer.reset-size10.size10 {\n    /* stylelint-disable-next-line */\n    font-size: 1em;\n  }\n  .katex .sizing.reset-size10.size11,\n  .katex .fontsize-ensurer.reset-size10.size11 {\n    /* stylelint-disable-next-line */\n    font-size: 1.1996142719em;\n  }\n  .katex .sizing.reset-size11.size1,\n  .katex .fontsize-ensurer.reset-size11.size1 {\n    /* stylelint-disable-next-line */\n    font-size: 0.2009646302em;\n  }\n  .katex .sizing.reset-size11.size2,\n  .katex .fontsize-ensurer.reset-size11.size2 {\n    /* stylelint-disable-next-line */\n    font-size: 0.2411575563em;\n  }\n  .katex .sizing.reset-size11.size3,\n  .katex .fontsize-ensurer.reset-size11.size3 {\n    /* stylelint-disable-next-line */\n    font-size: 0.2813504823em;\n  }\n  .katex .sizing.reset-size11.size4,\n  .katex .fontsize-ensurer.reset-size11.size4 {\n    /* stylelint-disable-next-line */\n    font-size: 0.3215434084em;\n  }\n  .katex .sizing.reset-size11.size5,\n  .katex .fontsize-ensurer.reset-size11.size5 {\n    /* stylelint-disable-next-line */\n    font-size: 0.3617363344em;\n  }\n  .katex .sizing.reset-size11.size6,\n  .katex .fontsize-ensurer.reset-size11.size6 {\n    /* stylelint-disable-next-line */\n    font-size: 0.4019292605em;\n  }\n  .katex .sizing.reset-size11.size7,\n  .katex .fontsize-ensurer.reset-size11.size7 {\n    /* stylelint-disable-next-line */\n    font-size: 0.4823151125em;\n  }\n  .katex .sizing.reset-size11.size8,\n  .katex .fontsize-ensurer.reset-size11.size8 {\n    /* stylelint-disable-next-line */\n    font-size: 0.578778135em;\n  }\n  .katex .sizing.reset-size11.size9,\n  .katex .fontsize-ensurer.reset-size11.size9 {\n    /* stylelint-disable-next-line */\n    font-size: 0.6945337621em;\n  }\n  .katex .sizing.reset-size11.size10,\n  .katex .fontsize-ensurer.reset-size11.size10 {\n    /* stylelint-disable-next-line */\n    font-size: 0.8336012862em;\n  }\n  .katex .sizing.reset-size11.size11,\n  .katex .fontsize-ensurer.reset-size11.size11 {\n    /* stylelint-disable-next-line */\n    font-size: 1em;\n  }\n  .katex .delimsizing.size1 {\n    font-family: KaTeX_Size1;\n  }\n  .katex .delimsizing.size2 {\n    font-family: KaTeX_Size2;\n  }\n  .katex .delimsizing.size3 {\n    font-family: KaTeX_Size3;\n  }\n  .katex .delimsizing.size4 {\n    font-family: KaTeX_Size4;\n  }\n  .katex .delimsizing.mult .delim-size1 > span {\n    font-family: KaTeX_Size1;\n  }\n  .katex .delimsizing.mult .delim-size4 > span {\n    font-family: KaTeX_Size4;\n  }\n  .katex .nulldelimiter {\n    display: inline-block;\n    width: 0.12em;\n  }\n  .katex .delimcenter {\n    position: relative;\n  }\n  .katex .op-symbol {\n    position: relative;\n  }\n  .katex .op-symbol.small-op {\n    font-family: KaTeX_Size1;\n  }\n  .katex .op-symbol.large-op {\n    font-family: KaTeX_Size2;\n  }\n  .katex .op-limits > .vlist-t {\n    text-align: center;\n  }\n  .katex .accent > .vlist-t {\n    text-align: center;\n  }\n  .katex .accent .accent-body {\n    position: relative;\n  }\n  .katex .accent .accent-body:not(.accent-full) {\n    width: 0;\n  }\n  .katex .overlay {\n    display: block;\n  }\n  .katex .mtable .vertical-separator {\n    display: inline-block;\n    min-width: 1px;\n  }\n  .katex .mtable .arraycolsep {\n    display: inline-block;\n  }\n  .katex .mtable .col-align-c > .vlist-t {\n    text-align: center;\n  }\n  .katex .mtable .col-align-l > .vlist-t {\n    text-align: left;\n  }\n  .katex .mtable .col-align-r > .vlist-t {\n    text-align: right;\n  }\n  .katex .svg-align {\n    text-align: left;\n  }\n  .katex svg {\n    display: block;\n    position: absolute;\n    width: 100%;\n    height: inherit;\n    fill: currentColor;\n    stroke: currentColor;\n    fill-rule: nonzero;\n    fill-opacity: 1;\n    stroke-width: 1;\n    stroke-linecap: butt;\n    stroke-linejoin: miter;\n    stroke-miterlimit: 4;\n    stroke-dasharray: none;\n    stroke-dashoffset: 0;\n    stroke-opacity: 1;\n  }\n  .katex svg path {\n    stroke: none;\n  }\n  .katex img {\n    border-style: none;\n    min-width: 0;\n    min-height: 0;\n    max-width: none;\n    max-height: none;\n  }\n  .katex .stretchy {\n    width: 100%;\n    display: block;\n    position: relative;\n    overflow: hidden;\n  }\n  .katex .stretchy::before, .katex .stretchy::after {\n    content: \"\";\n  }\n  .katex .hide-tail {\n    width: 100%;\n    position: relative;\n    overflow: hidden;\n  }\n  .katex .halfarrow-left {\n    position: absolute;\n    left: 0;\n    width: 50.2%;\n    overflow: hidden;\n  }\n  .katex .halfarrow-right {\n    position: absolute;\n    right: 0;\n    width: 50.2%;\n    overflow: hidden;\n  }\n  .katex .brace-left {\n    position: absolute;\n    left: 0;\n    width: 25.1%;\n    overflow: hidden;\n  }\n  .katex .brace-center {\n    position: absolute;\n    left: 25%;\n    width: 50%;\n    overflow: hidden;\n  }\n  .katex .brace-right {\n    position: absolute;\n    right: 0;\n    width: 25.1%;\n    overflow: hidden;\n  }\n  .katex .x-arrow-pad {\n    padding: 0 0.5em;\n  }\n  .katex .cd-arrow-pad {\n    padding: 0 0.55556em 0 0.27778em;\n  }\n  .katex .x-arrow,\n  .katex .mover,\n  .katex .munder {\n    text-align: center;\n  }\n  .katex .boxpad {\n    padding: 0 0.3em;\n  }\n  .katex .fbox,\n  .katex .fcolorbox {\n    box-sizing: border-box;\n    border: 0.04em solid;\n  }\n  .katex .cancel-pad {\n    padding: 0 0.2em;\n  }\n  .katex .cancel-lap {\n    margin-left: -0.2em;\n    margin-right: -0.2em;\n  }\n  .katex .sout {\n    border-bottom-style: solid;\n    border-bottom-width: 0.08em;\n  }\n  .katex .angl {\n    box-sizing: border-box;\n    border-top: 0.049em solid;\n    border-right: 0.049em solid;\n    margin-right: 0.03889em;\n  }\n  .katex .anglpad {\n    padding: 0 0.03889em;\n  }\n  .katex .eqn-num::before {\n    counter-increment: katexEqnNo;\n    content: \"(\" counter(katexEqnNo) \")\";\n  }\n  .katex .mml-eqn-num::before {\n    counter-increment: mmlEqnNo;\n    content: \"(\" counter(mmlEqnNo) \")\";\n  }\n  .katex .mtr-glue {\n    width: 50%;\n  }\n  .katex .cd-vert-arrow {\n    display: inline-block;\n    position: relative;\n  }\n  .katex .cd-label-left {\n    display: inline-block;\n    position: absolute;\n    right: calc(50% + 0.3em);\n    text-align: left;\n  }\n  .katex .cd-label-right {\n    display: inline-block;\n    position: absolute;\n    left: calc(50% + 0.3em);\n    text-align: right;\n  }\n  \n  .katex-display {\n    display: block;\n    margin: 1em 0;\n    text-align: center;\n  }\n  .katex-display > .katex {\n    display: block;\n    text-align: center;\n    white-space: nowrap;\n  }\n  .katex-display > .katex > .katex-html {\n    display: block;\n    position: relative;\n  }\n  .katex-display > .katex > .katex-html > .tag {\n    position: absolute;\n    right: 0;\n  }\n  \n  .katex-display.leqno > .katex > .katex-html > .tag {\n    left: 0;\n    right: auto;\n  }\n  \n  .katex-display.fleqn > .katex {\n    text-align: left;\n    padding-left: 2em;\n  }\n  \n  body {\n    counter-reset: katexEqnNo mmlEqnNo;\n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
